'use strict';

exports.__esModule = true;

var _isEvent = require('./isEvent');

var _isEvent2 = _interopRequireDefault(_isEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var silenceEvent = function silenceEvent(event) {
  var is = (0, _isEvent2.default)(event);
  if (is) {
    event.preventDefault();
  }
  return is;
};

exports.default = silenceEvent;


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/lib/events/silenceEvent.js
// module id = 450
// module chunks = 0